export default function stringify(object) {
    return JSON.stringify(object, null, 4);
}
